import {AfterViewInit, Component, ElementRef, Inject, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {
  ActionButtonControl,
  ButtonControl,
  firstNestedActionButtonControl,
  flatMap,
  hasGruppeTechnischeSteuerung,
  UIArtefakt,
  UiInputControl
} from '../../../models/uiArtefakt';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ModulDialogComponent} from '../../popupDialog/uivorgang-dialog/modul-dialog.component';
import {EventService} from '../../../services/event.service';
import {ValidationService} from '../../../services/validation.service';
import {interval, Observable, Subscription} from 'rxjs';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {UiControl} from '../../../models/uiControl';
import {delay, filter, map, take, tap} from 'rxjs/operators';
import {ModalDialogButtonViewComponent, ModalDialogButtonViewInput} from './modal-dialog-button-view/modal-dialog-button-view.component';
import {UiUpdateService} from '../../../services/ui-update.service';
import {EnumGruppeTechnischeSteuerung} from '../../../models/enumGruppeTechnischeSteuerung';
import {FondsService} from '../../../services/fonds.service';
import {EnumButtonAktionsTyp} from '../../../models/enumButtonAktionsTyp';
import {ButtonCommandService} from '../../../services/button-command.service';
import {TrackingAktion} from '../../../models/enumTracking';
import {TrackingService} from '../../../services/tracking.service';
import {Notification, NotificationService} from '@lv1871/core';

@Component({
    selector: 'lv-modal-dialog-button',
    templateUrl: './modal-dialog-button.component.html',
    styleUrls: ['./modal-dialog-button.component.scss'],
    standalone: false
})
export class ModalDialogButtonComponent implements OnInit, OnDestroy, AfterViewInit {

  public isDisabled: boolean = false;
  public uiAusrichtung: UIAusrichtung;
  public isAngebotserstellungMoeglichJNRelevant: boolean = false;
  private _isUIControlsRequestPendingSubsciption: Subscription;
  private _isUIControlsRequestPending: boolean;
  private _uiArtefakt: ButtonControl;
  private _identifikator: string;
  private _titel: string;
  private _uiControl: UiControl;
  private _uiControlSubscription = Subscription.EMPTY;
  private _modalDialogSubscription = Subscription.EMPTY;

  constructor(public dialogRef: MatDialogRef<ModulDialogComponent>,
              public eventService: EventService, private _validationService: ValidationService,
              private _buttonCommandService: ButtonCommandService,
              private _fondsService: FondsService,
              private _notificationService: NotificationService,
              private matDialog: MatDialog, private _uiUpdateService: UiUpdateService,
              @Inject(MAT_DIALOG_DATA) public data: ModalDialogButtonViewInput,
              private _renderer: Renderer2, private _element: ElementRef,
              private _tracker: TrackingService) {
  }

  get uiArtefakt(): ButtonControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: ButtonControl) {
    this._uiArtefakt = uiArtefakt;
    this._identifikator = uiArtefakt.Identifikator;
    this._titel = uiArtefakt.Titel;
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public ngOnInit(): void {
    this._isUIControlsRequestPendingSubsciption = this.eventService.uiControlsRequestPending$
        .subscribe(pending => this._isUIControlsRequestPending = pending);
    this.isAngebotserstellungMoeglichJNRelevant =
        hasGruppeTechnischeSteuerung(this.uiArtefakt, EnumGruppeTechnischeSteuerung.ANGEBOTSERSTELLUNGMOEGLICHJNVALIDIERUNG);
    this._uiControlSubscription =
        this.eventService.uiControls$.subscribe(uiControl => {
          this._uiControl = uiControl;
          const buttonControl = this._findButton(uiControl);
          if (buttonControl) {
            flatMap(buttonControl.UIArtefakt).map(artefakt => artefakt as UiInputControl)
                .filter(artefakt => artefakt.Darstellungsart !== UIDarstellungsart.AUSGEBLENDET)
                .forEach(artefakt => {
                  artefakt.PflichtfeldJN = true;
                });
          }
        });
  }

  ngOnDestroy(): void {
    if (this._uiControlSubscription) {
      this._uiControlSubscription.unsubscribe();
    }
    if (this._modalDialogSubscription) {
      this._modalDialogSubscription.unsubscribe();
    }
    if (this._isUIControlsRequestPendingSubsciption) {
      this._isUIControlsRequestPendingSubsciption.unsubscribe();
    }
  }

  public openModalDialog() {
    this.trackDownloadButton(this.uiArtefakt);
    if (this.isAngebotserstellungMoeglichJNRelevant) {
      if (!this.eventService.angebotserstellungMoeglichJN$.value) {
        const notification = new Notification(
            'Alert', 'Danger', '',
            this._uiArtefakt.Text + ' kann nicht ausgeführt werden. Bitte überprüfen Sie Ihre Eingaben.', true, null);
        this._notificationService.addNotification(notification);
        return;
      }
    }
    this._openModalDialog(
        this.eventService.uiControls$.pipe(
            map(control => this._findButton(control))),
        this.eventService.uiControls$.pipe(
            map(control => firstNestedActionButtonControl(this._findButton(control).UIArtefakt))
        ));
  }

  private _openModalDialog(modul$: Observable<UIArtefakt>, actionButton$: Observable<ActionButtonControl>) {
    const prevUIArtefaktDeepCopy = JSON.parse(JSON.stringify(this.uiArtefakt));
    this._handleModalDialogGeoeffnetJNStatus(true);

    this._modalDialogSubscription = this.matDialog.open<ModalDialogButtonViewComponent,
        ModalDialogButtonViewInput, string>(ModalDialogButtonViewComponent, {
      data: {
        buttonComponent: this.uiArtefakt.ButtonComponent,
        titel: this._titel, actionButton$, modul$
      } as ModalDialogButtonViewInput,
      panelClass: 'lv-modal-dialog',
      disableClose: true,
      autoFocus: false,
      minWidth: '65%',
      minHeight: '85%'
    }).afterClosed().subscribe(aktion => {
      this.eventService.uiControlsRequestPending$.next(true);
      if (!!aktion) {
        switch (aktion) {
          case EnumButtonAktionsTyp.MODALDIALOG_ABBRECHEN:
            flatMap(prevUIArtefaktDeepCopy.UIArtefakt)
                .forEach(prevArtefakt => {
                  flatMap(this._uiControl.uiVorgang.UIArtefakt)
                      .filter(aktArtefakt => prevArtefakt.IdentifikatorUuid === aktArtefakt.IdentifikatorUuid)
                      .map(aktArtefaktNew => {
                        aktArtefaktNew.WertEingabe = prevArtefakt.WertEingabe;
                      });
                });
            this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
            break;
          case EnumButtonAktionsTyp.MODALDIALOG_SCHLIESSEN:
            this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
            break;
          case EnumButtonAktionsTyp.ELEKTRONISCHUNTERSCHREIBEN_NICHT_MOEGLICH:
            this._buttonCommandService.handleActionButtonAktionstyp(EnumButtonAktionsTyp.ELEKTRONISCHUNTERSCHREIBEN_NICHT_MOEGLICH)
                .subscribe(_ => this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt)
                );
            break;
          default:
            this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
        }
      }
      this._handleModalDialogGeoeffnetJNStatus(false);
    });
  }

  private _handleModalDialogGeoeffnetJNStatus(dialogGeoeffnet: boolean) {
    flatMap(this._uiControl.uiVorgang.UIArtefakt)
        .filter(artefakt => artefakt.FeldnameExtern === '/modaldialogGeoeffnet')
        .map(artefakt => {
          artefakt.WertEingabe = dialogGeoeffnet;
        });
    this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
    // Zeitversatz wegen dem Sichtbarkeitsproblem der Buttons nach Schließen des ModalDialogs
    if (!dialogGeoeffnet) {
      interval(100).pipe(
          delay(350),
          filter(_ => !this._isUIControlsRequestPending),
          take(1),
          tap(_ => {
            this.eventService.modalDialogGeoeffnet$.next(dialogGeoeffnet);
          })
      ).subscribe();
    } else {
      this.eventService.modalDialogGeoeffnet$.next(dialogGeoeffnet);
    }
  }

  private _findButton(control: UiControl): UIArtefakt {
    return flatMap(control.uiVorgang.UIArtefakt)
        .filter(artefakt => artefakt.Identifikator === this._identifikator)[0];
  }

  private trackDownloadButton(uiArtefakt: ButtonControl) {
    if (uiArtefakt.FeldnameTracking) {
      this._tracker.trackEvent(this.uiArtefakt.ButtonComponent, TrackingAktion.T_BUTTON, this.uiArtefakt.FeldnameTracking);
    }
  }
}
